import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import Logo from 'layouts/subcomponents/Logo'
import styles from 'layouts/DoublePanelViewLayout/DoublePanelViewLayout.module.scss'
import {
  CloseButton,
  Content,
  Header,
  Side,
} from 'layouts/DoublePanelViewLayout/subcomponents'

export const DoublePanelViewLayout = ({
  children = null,
  side = null,
  onClose = () => {},
  contentClassName = '',
  sideContainerClassname = '',
}) => (
  <section className={styles.layout}>
    <Header
      className={clsx(
        'double-panel-view-layout__header',
        styles.layout__header,
      )}
    >
      <Logo className={styles['layout__logo']} />
      <CloseButton onClose={onClose} />
    </Header>
    <Content
      className={clsx(styles.layout__content, contentClassName, {
        [styles['layout__content_centered']]: !side,
      })}
    >
      {children}
    </Content>
    {side && (
      <Side className={clsx(styles.layout__side, sideContainerClassname)}>
        {side}
      </Side>
    )}
  </section>
)

DoublePanelViewLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]).isRequired,
  side: PropTypes.element,
  onClose: PropTypes.func,
  contentClassName: PropTypes.string,
  sideContainerClassname: PropTypes.string,
}
